import React from 'react';
import { Layout } from '../components/shared/layout/layout';
import { Typography } from '@material-tailwind/react';
import StripePricingTable from '../components/shared/StripePricingTable';
import { useUser } from '@auth0/nextjs-auth0';
import { STRIPE_CONFIG, PRICING_TABLES } from '../utils/constants/stripe';

import { useRouter } from 'next/router';
import { Loader2 } from 'lucide-react';

const PricingPage = () => {
  const { user, isLoading } = useUser();
  const router = useRouter();
  const isOnboarding = router.query.onboarding === 'true';

  // Use env var if set (production), otherwise fall back to current origin (works for localhost too)
  const baseUrl =
    process.env.NEXT_PUBLIC_APP_URL ||
    (typeof window !== 'undefined' ? window.location.origin : '');

  // const successUrl = `${baseUrl}/signup/success`;
  // const cancelUrl = `${baseUrl}/pricing`;
  const pageContent = (
    <div className="min-h-screen bg-[#FDFDFD]">
      {/* Premium Header Section */}
      <div className="relative overflow-hidden bg-white border-b border-gray-100">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[600px] bg-gradient-to-b from-[#2CA6A4]/5 to-transparent rounded-full blur-3xl -z-10 opacity-60" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 text-center">
          <Typography
            variant="h1"
            className="text-2xl md:text-4xl font-black text-gray-900 tracking-tight mb-4"
          >
            Empower your <span className="text-[#2CA6A4]">Connections</span>
          </Typography>
          <Typography
            variant="lead"
            className="max-w-2xl mx-auto text-xl text-gray-600 font-medium leading-relaxed"
          >
            Unlock advanced networking features, CRM integrations, and voice
            transcription to supercharge your reach.
          </Typography>
        </div>
      </div>

      {/* Pricing Tables Section */}
      <div className="max-w-7xl mx-auto py-2 px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-6">
          {PRICING_TABLES.map((tableId, index) => (
            <div key={tableId}>
              <div className="mb-4 text-center">
                <Typography
                  variant="h3"
                  className="text-2xl font-bold text-gray-900"
                >
                  {index === 0 ? '' : 'Team & Enterprise Solutions'}
                </Typography>
                <div className="h-1 w-20 bg-[#2CA6A4]/20 mx-auto mt-2 rounded-full" />
              </div>
              {user && (
                <StripePricingTable
                  pricingTableId={tableId}
                  publishableKey={STRIPE_CONFIG.PUBLISHABLE_KEY}
                  customerEmail={user?.email || undefined}
                  clientReferenceId={user.sub || undefined}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  if (isLoading) {
    const loader = (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="animate-spin" />
      </div>
    );
    return isOnboarding ? loader : <Layout>{loader}</Layout>;
  }

  return isOnboarding ? pageContent : <Layout>{pageContent}</Layout>;
};

export default PricingPage;
